import { ExtendDirectionDTO } from '@/modules/common/types/dto/extend-direction.dto';
import { ExtendDirection } from '@/modules/common/types/extend-direction';

/**
 * Maps domain ExtendDirection to DTO for API requests
 */
export const mapExtendDirectionToDTO = (direction: ExtendDirection): ExtendDirectionDTO => {
  switch (direction) {
    case ExtendDirection.Previous:
      return ExtendDirectionDTO.PREVIOUS;
    case ExtendDirection.Next:
      return ExtendDirectionDTO.NEXT;
    default:
      return ExtendDirectionDTO.PREVIOUS;
  }
};

/**
 * Maps DTO ExtendDirection to domain model (for future use)
 */
export const mapExtendDirectionFromDTO = (dto: ExtendDirectionDTO): ExtendDirection => {
  switch (dto) {
    case ExtendDirectionDTO.PREVIOUS:
      return ExtendDirection.Previous;
    case ExtendDirectionDTO.NEXT:
      return ExtendDirection.Next;
    default:
      return ExtendDirection.Previous;
  }
};
